import classNames from "classnames";
import React from "react";
import FormattedName from "shared/FormattedName";
import PinIcon from "shared/PinIcon";
import styles from "./index.module.css";

/**
 * IBO name badge. Styled based on pin level.
 */
export default function NameBubble({ iboNumber, pinLevel, fullName, onClick }) {
  return (
    <div className={styles.container} key={iboNumber}>
      <div
        onClick={onClick}
        className={classNames(styles.nameBubble, {
          [styles.interactive]: onClick != null,
          [styles.diamond]: pinLevel === 4,
          [styles.emerald]: pinLevel === 3,
          [styles.platinum]: pinLevel === 2,
        })}
      >
        <div className={styles.icon}>
          <PinIcon pinLevel={pinLevel} />
        </div>

        <div className={styles.name}>
          <FormattedName value={fullName ?? "no name"} />
        </div>
      </div>
    </div>
  );
}
